import { PatientPreferencesResponse } from "../../../../../../../services/api-client/contact-api";
import { CommunicationStatus } from "../types/communication-status";
import { getCustomizedPhoneCount } from "./get-customized-phone-count";

export const getPhoneStatus = (patientPreferences: PatientPreferencesResponse) => {
  const count = getCustomizedPhoneCount(patientPreferences);

  if (count === 0) return CommunicationStatus.none;
  return CommunicationStatus.all;
};